import type { SystemRolePermissionId } from '@clockwise/shared';
import type { ReactNode } from 'react';
import { useHasPermission } from '@/lib/permissions';

interface Props {
  permission: SystemRolePermissionId;
  children: ReactNode;
  /** Rendered in place of the children when the user lacks the permission. */
  fallback?: ReactNode;
}

/**
 * Render the children only when the calling user has `permission`. Otherwise
 * renders `fallback` (defaults to nothing).
 *
 * Use for action-button gating (`<Add>`, `<Edit>`, `<Delete>`) and inline
 * sections of a page. Route-level access blocks should use `<NoAccess>`
 * instead so the user gets explicit feedback rather than silence.
 */
export function RequirePermission({ permission, children, fallback = null }: Props) {
  const allowed = useHasPermission(permission);
  return <>{allowed ? children : fallback}</>;
}
